import React from "react";
import ImageComponent from "../../../Components/Common/ImageComponent";

const OrderProduct = ({ menuItem = {} }) => {
  const orderDetails = menuItem?.menuOrderDetails || [];
  const subTotal = orderDetails.reduce(
    (acc, item) => acc + item?.menuItemDetail?.price * item?.quantity,
    0
  );
  const discount = menuItem?.discountAmount || 0;
  const finalAmount = subTotal - discount;

  // Status colors
  const statusColors = {
    Ongoing: "bg-info-subtle text-info", // Blue
    Received: "bg-primary-subtle text-primary", // Purple
    Processing: "bg-warning-subtle text-warning", // Yellow
    Ready: "bg-success-subtle text-success", // Green
    Delivering: "bg-secondary-subtle text-secondary", // Gray
    Cancelled: "bg-danger-subtle text-danger", // Red
    Completed: "bg-success-subtle text-success", // Green
  };

  return (
    <>
      {orderDetails.map((item, index) => (
        <tr key={index}>
          <td>
            <div className="d-flex">
              <div className="flex-shrink-0 avatar-md bg-light rounded p-1">
                <ImageComponent
                  className="card-img-top menuItem img-fluid"
                  fileId={item?.menuItemDetail?.cloudR2ImagePath}
                  alt={item?.menuItemDetail?.title}
                  style={{ height: "64px", width: "100px" }}
                />
              </div>
              <div className="flex-grow-1 ms-3">
                <h5 className="fs-16">
                  <a
                    className="link-primary"
                  >
                    {item?.menuItemDetail?.title}
                  </a>
                </h5>
                <p className="text-muted mb-0">
                  Category:{" "}
                  <span className="fw-medium">
                    {item?.menuItemDetail?.menuCategory}
                  </span>
                </p>
              </div>
            </div>
          </td>
          <td>{item?.menuItemDetail?.price}</td>
          <td>{item?.quantity}</td>
          <td>
            <span className={`badge ${statusColors[menuItem?.orderStatus] || "bg-light text-dark"}`}>
              {menuItem?.orderStatus || "N/A"}
            </span>
          </td>
          <td className="fw-medium text-end">
            {item?.menuItemDetail?.price * item?.quantity}
          </td>
        </tr>
      ))}

      {/* Totals Section */}
      <tr className="border-top border-top-dashed">
        <td colSpan="3"></td>
        <td colSpan="2" className="fw-medium p-0">
          <table className="table table-borderless mb-0">
            <tbody>
              <tr>
                <td>Sub Total ({orderDetails[0]?.menuItemDetail?.currency}) :</td>
                <td className="text-end">{subTotal}</td>
              </tr>
              <tr>
                <td>
                  Discount ({orderDetails[0]?.menuItemDetail?.currency}) :
                </td>
                <td className="text-end">{discount}</td>
              </tr>
              <tr className="border-top border-top-dashed">
                <th scope="row">
                  Total ({orderDetails[0]?.menuItemDetail?.currency}) :
                </th>
                <th className="text-end">{finalAmount}</th>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </>
  );
};

export default OrderProduct;